import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from "@/store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,

  routes: [
    {
      path: "/",
      name: "login",
      component: () => import(/* webpackChunkName: "about" */ "./views/Login.vue")
    },
    {
      path: "/login",
      name: "login",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Login.vue")
    },
    {
      path: "/pinboard",
      name: "pinboard",
      meta: { requiresAuth: true, },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/PinBoard.vue"),
      children: [
        {
          path: ":pinBoardId",
          name: "currentPinboard",
          // component: () => import(/* webpackChunkName: "about" */ "./views/About.vue")
        },
        {
          path: ":pinBoardId/card/:cardid",
          name: "currentCard",
          // component: () => import(/* webpackChunkName: "about" */ "./views/About.vue")
        }
      ]
    },
    {
      path: "/admin",
      name: "admin",
      meta: { requiresAuth: true, requiresUser: "Admin" },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Admin/Admin.vue")
    },
    {
      path: "/admin/job",
      name: "adminJob",
      meta: { requiresAuth: true, requiresUser: "Admin" },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Admin/AdminJob.vue")
    },
    {
      path: "/admin/pinboard",
      name: "adminPinboard",
      meta: { requiresAuth: true, requiresUser: "Admin" },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Admin/AdminPinboard.vue")
    },
    {
      path: "/admin/category",
      name: "adminCategory",
      meta: { requiresAuth: true, requiresUser: "Admin" },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Admin/AdminCategory.vue")
    },
    {
      path: "/admin/user",
      name: "adminUser",
      meta: { requiresAuth: true, requiresUser: "Admin" },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Admin/AdminUser.vue")
    },
    {
      path: "/admin/card",
      name: "adminCard",
      meta: { requiresAuth: true, requiresUser: "Admin" },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Admin/AdminCard.vue")
    },
    {
        path: "/admin/statistic",
        name: "statistic",
        meta: { requiresAuth: true, requiresUser: "Admin" },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ "./views/Admin/AdminStatistic.vue")
      },
  ]
});

router.beforeEach((to: any, from: any, next: any) => {

  if (to.name === "login") {
    if (store.getters["auth/isAuthenticated"]) {
      return next({
        path: "/pinboard",
        query: { redirect: to.fullPath },
      });
    }
  }
  if (to.matched.some((record: any) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters["auth/isAuthenticated"]) {
      store.dispatch("auth/authLogout");
      return next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    }
    // else{
    //   router.push("/pinboard");
    // }
  }
  if (to.matched.some((record: any) => record.meta.requiresUser)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.

    if (!store.getters["auth/isAdmin"]) {
      store.dispatch("auth/authLogout");
      return next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    }
  }
  next();
});

export default router;
